import type { InvitationGrant } from '../service/invitation.service';

/** The role a grant names: a built-in role, or the custom role's own name. */
export const grantRoleLabel = (grant: InvitationGrant): string =>
  grant.role ?? grant.custom_role_name ?? 'Custom role';

/** A grant as one line: "Workspace — Role". */
export const grantLine = (grant: InvitationGrant): string =>
  `${grant.node_name} — ${grantRoleLabel(grant)}`;

/** Who is inviting, as a heading: the organisation, or the platform for a support admin. */
export const invitationIssuer = (invitation: {
  organisation_name: string | null;
  platform_role: string | null;
}): string => {
  if (invitation.platform_role) return 'SeeWard platform';
  return invitation.organisation_name || 'An organisation';
};

/** What accepting gives, as a sentence fragment a reader can check before they say yes. */
export const invitationOffer = (invitation: {
  platform_role: string | null;
  grants: InvitationGrant[];
}): string => {
  if (invitation.platform_role) return 'Support admin (read-only access to the platform console)';
  return invitation.grants.map(grantLine).join(', ');
};
